import { nanoid } from 'nanoid'
import React from 'react'
import { checkTextTranslation, checkTranslation, setObject, translate } from '../../utils/useful'
import FormViewer from '../FormViewer'
import { apisList } from '../../variables/config'


class FetchInput extends React.Component {
    state = {
        choiceOption: [
            {}
        ],
        firtRow: { title: '', value: nanoid() },
        fields: [

            { key: 'name', type: 'TextInput', col: '6', information: { isSearchable: true, label: '{{lang}}Param name', hint: "{{lang}}The fetched value can be recalled in the page using this name.", required: true }, },

            // {
            //     key: 'api', type: 'ApisInput', information: { label: '{{lang}}API', type: 'local', items: [], placeholder: '{{lang}}select', required: true },
            //     dependencies: [
            //         {
            //             refKey: 'collection', targetKey: 'api',
            //             conditions: [{
            //                 root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
            //                 effect: { changeHeader: [{ key: 'information.frames', value: '@data.collection' }] }
            //             }],
            //             init: true,

            //         },
            //     ]
            // },

            { key: 'api', type: 'SelectInput', col: '6', information: { label: '{{lang}}API', type: 'local', default: 'getSingleRecord', items: [{ title: '{{lang}}Get single record', value: 'getSingleRecord' }, { title: '{{lang}}Get report', value: 'getChartInfo' }], placeholder: '{{lang}}select', required: true }, },



            // {
            //     key: 'frames', type: 'FrameSelectInput', information: { isSearchable: true, multiple: false, label: '{{lang}}Frames', address: 'getFramesApplet', filter: { appletPopulate: true, appletHub: '{{appletHub}}', type: ['collection', 'folder'] }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type', mode: 'mode', name: 'name', cDate: 'cDate', applet: 'applet' }, type: 'api', placeholder: '{{lang}}Select frames', required: true },
            //     dependencies: [
            //         {
            //             refKey: 'api', targetKey: 'frames',
            //             conditions: [{
            //                 root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.api' }, operator: { value: '==' }, target: { value: 'getSingleRecord' } } }, },
            //                 effect: { show: true, }
            //             }],
            //             else: { show: false },
            //             init: true,

            //         },
            //     ]
            // },


            {
                key: 'frames', type: 'FrameSelectInput', information: { isSearchable: true, multiple: true, label: '{{lang}}Frames', address: 'getFramesApplet', filter: { appletPopulate: true, appletHub: '{{appletHub}}', type: ['collection', 'folder'] }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type', mode: 'mode', name: 'name', cDate: 'cDate', applet: 'applet' }, type: 'api', placeholder: '{{lang}}Select frames', required: true },
                dependencies: [
                    {
                        refKey: 'api', targetKey: 'frames',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.api' }, operator: { value: '==' }, target: { value: 'getChartInfo' } } }, },
                            effect: { changeHeader: [{ key: 'information.label', value: '{{lang}}frames' }, { key: 'information.multiple', value: true }] }
                        }],
                        else: { changeHeader: [{ key: 'information.label', value: '{{lang}}frame' }, { key: 'information.multiple', value: false }] },
                        init: true,

                    },
                ]
            },


            // { key: 'collection', type: 'AdvancedMultiTreeSelect', col: '6', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: true }, },

            {
                key: 'x_axis', type: 'SelectInput', col: '12', information: { label: '{{lang}}Main grouping field', type: 'api', address: 'getFramesFieldsList', filter: { frames: "{{frames*}}" }, fields: { title: 'information.label', value: 'key', }, placeholder: '{{lang}}select', required: true },
                dependencies: [
                    {
                        refKey: ['api', 'frames'], targetKey: 'x_axis',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.api' }, operator: { value: '==' }, target: { value: 'getChartInfo' } }, 2: { id: 2, source: { value: '@data.frames' }, operator: { value: '!=' }, target: { value: null } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,
                        // show:true,

                    }
                ],
                disabled: false
            },



            // {
            //     key: 'fieldValue', type: 'FieldValueInput', col: '6', information: { label: '{{lang}}Filter value', type: 'api', address: 'getFramesFieldsList', filter: { frames: "{{frames*}}" }, fields: { title: 'information.label', value: 'key', }, placeholder: '{{lang}}select', required: true },
            //     dependencies: [{
            //         refKey: 'frames', targetKey: 'fieldValue',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.frames' }, operator: { value: '!=' }, target: { value: null } } }, },
            //             effect: { changeHeader: [{ key: 'disabled', value: false }] }
            //         }],
            //         else: { changeHeader: [{ key: 'disabled', value: true }] },
            //         init: true,
            //         // show:true,

            //     },


            //     ],
            //     disabled: false
            // },




            // {
            //     key: 'x_axis', type: 'SelectInput', information: { label: '{{lang}}Filter field', type: 'api', address: 'getFramesFieldsList', filter: { frames: "{{frames*}}" }, fields: { title: 'information.label', value: 'key', }, placeholder: '{{lang}}select', required: true },
            //     dependencies: [{
            //         refKey: 'frames', targetKey: 'x_axis',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.frames' }, operator: { value: '!=' }, target: { value: null } } }, },
            //             effect: { changeHeader: [{ key: 'disabled', value: false }] }
            //         }],
            //         else: { changeHeader: [{ key: 'disabled', value: true }] },
            //         init: true,
            //         // show:true,

            //     },

            //     {
            //         refKey: 'api', targetKey: 'x_axis',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'table' } } }, },
            //             effect: { changeHeader: [{ key: 'information.label', value: 'Primary Grouping' }] }
            //         }],
            //         else: { changeHeader: [{ key: 'information.label', value: '{{lang}}X-Axis' }] },
            //         init: true,
            //         // show:true,

            //     }], disabled: false
            // },



            {
                key: 'fields', type: 'FieldsSelectInput', information: { label: '{{lang}}Data fields', type: 'api', address: 'getFramesFieldsList', filter: { frames: "{{frames*}}" }, placeholder: '{{lang}}select', required: true },
                dependencies: [
                    // {
                    //     refKey: 'frames', targetKey: 'fields',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.frames' }, operator: { value: '!=' }, target: { value: null } } }, },
                    //         effect: { show: true }
                    //     }],
                    //     else: { show: false },
                    //     init: true,
                    //     // show:true,

                    // },
                    {
                        refKey: ['api', 'frames'], targetKey: 'fields',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.api' }, operator: { value: '==' }, target: { value: 'getChartInfo' } }, 2: { id: 2, source: { value: '@data.frames' }, operator: { value: '!=' }, target: { value: null } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,
                        // show:true,

                    }
                ], disabled: false
            },


            {
                key: 'filter', type: 'FilterInput', information: { label: '{{lang}}Filter', inputClass: 'bordered-input', placeholder: '{{lang}}Add filter', required: true },
                dependencies: [
                    {
                        refKey: 'frames', targetKey: 'filter',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: '1' } } }, },
                            effect: { changeHeader: [{ key: 'information.frames', value: '@data.frames' }] }
                        }],
                        init: true,

                    },

                    // {
                    //     refKey: ['api'], targetKey: 'filter',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.api' }, operator: { value: '==' }, target: { value: 'getChartInfo' } } }, },
                    //         effect: { show: true }
                    //     }],
                    //     else: { show: false },
                    //     init: true,

                    // },
                ]
            },

        ]
    }


    componentDidMount() {

        // let apis = []

        // Object.entries(apisList)?.map(([key, value]) => {
        //     if (value.features) {
        //         let api = value
        //         api.value = key
        //         api.title = value.label
        //         apis.push(api)
        //     }
        // })

        // this.setState({ apis })

        // if (!this.props.data || this.props.data.length == 0) {
        //     this.addHandler()
        // }
    }

    changeInputValue(value) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    addHandler = () => {
        let data = this.props.data ?? []
        data.push({ value: nanoid() })
        this.changeInputValue(data)
    }


    removeHandler = (index) => {
        let data = this.props.data
        let indexx = index
        // let y=data.index[indexx]
        // console.log('eeeeeeee', index);
        // if (data.length < 2) {
        //     alert('nooooo')
        // } else {
        data.splice(index, 1)
        this.changeInputValue(data)
        // }
    }

    changeRowValue = (key, value, index) => {

        // console.log("changeRowValue")
        let data = this.props.data

        if (!Array.isArray(data)) {
            data = [{}]
        }
        // console.log(value)
        // data[index].title = value
        setObject(data[index], key, value)
        // console.log(data)
        this.changeInputValue(data)
    }


    liveChange = (data, init, key, value, extra, full) => {
        // console.log(extra)
        // console.log(extra)
        // console.log("liveChange", data, key, value, full)
        if (!init && (extra?.index != null)) {
            this.changeRowValue(key, value, extra.index)
        }

        if (init) {

            let fullData = this.props.data

            if (!Array.isArray(fullData)) {
                fullData = [{}]
            }

            fullData[extra.index] = data
            // setObject(data[index], key, value)
            // console.log(fullData)
            this.changeInputValue(fullData)
        }
    }



    render() {


        let list = Array.isArray(this.props.data) ? this.props.data : []

        // console.log(this.props.params)
        return (
            <div className=''>
                {Array.isArray(list) && list.map((item, index) => {
                    return (
                        <div className="w-100 flexc flex-column pt-2" style={{ borderBottom: '1px solid #eee' }}>
                            <FormViewer ref={el => this.form = el} initData={item} headers={this.state?.fields} formClass="bordered-form" inputClass={'bordered-input'} liveChange={this.liveChange} extra={{ index }} marginBottom={0} params={this.props.params} variables={this.props.variables} width={this.props.width} />
                            <div className='w-100 px-3 mb-3 flexce'>
                                <button style={{ color: '#ee5050' }} onClick={() => this.removeHandler(index)}>
                                    <p>{translate('Remove Row')}</p>
                                </button>
                            </div>
                        </div>
                    )
                })}
                <div className='px-3 py-2'>
                    <button className='' onClick={() => this.addHandler()}>
                        <p className='text-small text-semibold' style={{ color: '#007aff' }}>+ {translate("Add New Fetch")}</p>
                    </button>
                </div>
            </div>
        );
    }
}

export default FetchInput;